import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        HasEnrolments() { return this.enrolments.length > 0 },
        ActiveUNITeEnrolments() { return this.enrolments.filter(e => e.AcademicSession <= 2023 && ['P', 'R', 'L'].indexOf(e.EnrolmentStatusCode) > -1 && !e.CourseName.indexOf('Connect 2') > -1); },
        HasActiveUNITeEnrolments() { return this.ActiveUNITeEnrolments.length > 0; },
        Connect2Enrolments() { return this.enrolments.filter(e => e.AcademicSession <= 2023 && ['P', 'R', 'L'].indexOf(e.EnrolmentStatusCode) > -1 && !e.CourseName.indexOf('Connect 2') > -1); },
        HasConnect2Enrolments() { return this.Connect2Enrolments.length > 0; },
        ActiveREMSEnrolments() { return this.enrolments.filter(e => e.AcademicSession >= 2024 && ['PREENR', 'PEND', 'ENR', 'CUR'].indexOf(e.EnrolmentStatusCode) > -1); },
        HasActiveREMSEnrolments() { return this.ActiveREMSEnrolments.length > 0; },
        ActiveEnrolments() { return [...this.ActiveREMSEnrolments, ...this.Connect2Enrolments, ...this.ActiveUNITeEnrolments]; },
        HasActiveEnrolments() { return this.ActiveEnrolments.length > 0; },

        HasPreRegisteredEnrolments() { return this.enrolments.filter(e => ['P', 'PREENR', 'PEND'].indexOf(e.EnrolmentStatusCode) > -1).length > 0; },
        HasRegisteredOrCurrentEnrolments() { return this.enrolments.filter(e => ['L', 'R', 'ENR', 'CUR'].indexOf(e.EnrolmentStatusCode) > -1).length > 0; },
        HasHNEnrolments() { return this.FEEnrolments.filter(e => ['HC', 'HD'].indexOf(e.CourseCode.substring(0, 2)) > -1).length > 0; },

        HEEnrolments() { return this.ActiveEnrolments.filter(e => e.HEOrFE == 'HE' && e.IsFullTime === true && e.AcademicPartnershipTypeCode == null); },
        HasHEEnrolments() { return this.HEEnrolments.length > 0; },

        FEEnrolments() { return this.ActiveEnrolments.filter(e => e.HEOrFE == 'FE' && e.IsFullTime === true && e.AcademicPartnershipTypeCode == null); },
        HasFEEnrolments() { return this.FEEnrolments.length > 0; },
        CurrentFEEnrolments() { return this.ActiveEnrolments.filter(e => e.HEOrFE == 'FE' && e.IsFullTime === true && e.AcademicPartnershipTypeCode == null && e.EnrolmentStatusCode == 'CUR'); },
        HasCurrentFEEnrolments() { return this.CurrentFEEnrolments.length > 0; },

        FTEnrolments() { return this.ActiveEnrolments.filter(e => e.IsFullTime === true && e.AcademicPartnershipTypeCode == null); },
        HasFTEnrolments() { return this.FTEnrolments.length > 0; },

        PTEnrolments() { return this.ActiveEnrolments.filter(e => e.IsFullTime === false && e.AcademicPartnershipTypeCode == null); },
        HasPTEnrolments() { return this.PTEnrolments.length > 0; },

        AcademicPartnershipEnrolments() { return this.ActiveEnrolments.filter(e => !!e.AcademicPartnershipTypeCode); },
        HasAcademicPartnershipEnrolments() { return this.AcademicPartnershipEnrolments.length > 0; },
        IsAcademicPartnershipOnly() { return this.HasAcademicPartnershipEnrolments && this.ActiveEnrolments.length == this.AcademicPartnershipEnrolments.length; },

        FWDFEnrolments() { return this.ActiveEnrolments.filter(e => e.CourseName.indexOf('FWDF') > -1); },
        HasFWDFEnrolments() { return this.FWDFEnrolments.length > 0; },
        IsFWDFOnly() { return this.HasFWDFEnrolments && this.ActiveEnrolments.length == this.FWDFEnrolments.length; },

        ShortEnrolments() { return this.ActiveEnrolments.filter(e => e.OnboardingTypeCode == 'Short'); },
        HasShortEnrolments() { return this.ShortEnrolments.length > 0; },
        IsShortOnly() { return this.HasShortEnrolments && this.ActiveEnrolments.length == this.ShortEnrolments.length; },

        BlockReleaseEnrolments() { return this.ActiveEnrolments.filter(e => e.ModeOfAttendanceCode == '06'); },
        HasBlockReleaseEnrolments() { return this.BlockReleaseEnrolments.length > 0; },
        IsBlockReleaseOnly() { return this.HasBlockReleaseEnrolments && this.ActiveEnrolments.length == this.BlockReleaseEnrolments.length; },
    },
    methods: {
        ...mapActions({
            FetchStudentEnrolments: 'enterpriseDataApi/FetchStudentEnrolments',
            FetchStudentEnrolment: 'enterpriseDataApi/FetchStudentEnrolment',
        }),
        LoadStudentEnrolments(studentID) {
            this.loadingEnrolments = true;
            this.FetchStudentEnrolments({ StudentID: studentID })
                .then(response => {
                    this.enrolments = [...response];
                    eventBus.$emit('enrolments-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => this.loadingEnrolments = false);
        },
        LoadStudentEnrolment(enrolmentID) {
            eventBus.$emit('enrolment-fetch:started');
            this.FetchStudentEnrolment({ EnrolmentID: enrolmentID })
                .then(response => {
                    this.enrolment = Object.assign({}, response);
                    eventBus.$emit('enrolment-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('enrolment-fetch:finished'));
        },
    }
};